import { render, staticRenderFns } from "./aboveall.vue?vue&type=template&id=ed606296&scoped=true&"
import script from "./aboveall.vue?vue&type=script&lang=js&"
export * from "./aboveall.vue?vue&type=script&lang=js&"
import style0 from "./aboveall.vue?vue&type=style&index=0&id=ed606296&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed606296",
  null
  
)

export default component.exports